import { Accordion, Button, Typography } from '@fox/atoms';
import { nanoid } from 'nanoid';
import { MembershipFormFieldTypes, SwiftFoxOrganisationDetails, SwiftFoxPersonDetails } from '../../membership-form-template/contracts';
import { MembershipContactsField } from '../../membership-form-template/fields';
import { ProfileComponentProps } from './contracts';

export function ContactDetails<T>({ values, errors, setFieldValue, touched, isEditing, contactTypeRules }: ProfileComponentProps<T>) {
	return (
		<Accordion
			title={
				<Typography variant="h5" component="h3">
					{isEditing ? 'Edit contact details' : 'Contact details'}
				</Typography>
			}
		>
			<MembershipContactsField<SwiftFoxPersonDetails | SwiftFoxOrganisationDetails>
				key="contactDetails"
				field={{
					name: 'contactDetails',
					label: '',
					fieldType: MembershipFormFieldTypes.ContactsField
				}}
				isEditing={isEditing}
				errors={errors}
				setFieldValue={setFieldValue}
				value={values['contactDetails']}
				touched={touched}
				contactTypeRules={contactTypeRules}
			/>
			{isEditing ? (
				<Button
					sx={{ marginTop: '1rem' }}
					variant="secondary"
					startIconName="Add"
					onClick={() => {
						const contactsValue = [...values['contactDetails']];
						contactsValue.push({
							id: null,
							trackingId: nanoid(),
							type: '',
							value: ''
						});
						setFieldValue('contactDetails', contactsValue);
					}}
				>
					Add new
				</Button>
			) : null}
		</Accordion>
	);
}
